import React from 'react';
import { connect } from 'react-redux';
import { cartItemInstructionsUpdate } from '../../../actions/cartItem';

class MenuItemBottomButton extends React.Component {

    constructor(props) {
        super(props);

        this.onChangeInstructions = this.onChangeInstructions.bind(this);
    }

    onChangeInstructions(instructions) {
        this.props.dispatch(cartItemInstructionsUpdate(instructions))
    }

    render() {
        return (
            <div className="menu-item-bottom-button-window">
                <a
                    onClick={this.props.onButtonPress}
                >
                    <div className="topping-button-window">
                        <p className="toppingButton">{this.props.children}</p>
                    </div>
                </a>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        instructions: state.cartItem.instructions
    };
};

export default connect(mapStateToProps)(MenuItemBottomButton);